import React, { FC } from 'react';
import { TextField } from 'formik-material-ui';
import { Field, Form, Formik, FormikHelpers } from 'formik';
import { Button, Paper } from '@material-ui/core';
import { EditCustomerModel, useCustomer, } from 'hooks/customer';
import { toast } from 'react-toastify';
import { toFormikErrors } from 'utils/errorHandler';
import CustomFormGroup from 'components/CustomFormGroup';

interface EditCustomerProps {
  handleClose: () => void;
  customer: EditCustomerModel;
}

const EditCustomer: FC<EditCustomerProps> = (props) => {

  const { editCustomer } = useCustomer();

  const handleEditCustomer = async (values: EditCustomerModel, helpers: FormikHelpers<EditCustomerModel>) => {

    helpers.setSubmitting(true);

    const response = await editCustomer(values);

    if (response.generalError != null) {
      toast.error(response.generalError);
    }

    if (response.ok) {
      toast.success('Klant opgeslagen.');
      props.handleClose();
    } else if (response.errors) {
      const formikErrors = toFormikErrors(response.errors);
      helpers.setErrors(formikErrors);
    } else {
      toast.error('Onbekende fout. De klant kan op dit moment niet gewijzigd worden.');
    }
    helpers.setSubmitting(false);
  };

  return (
    <div>
      <Formik
        initialValues={{
          id: props.customer.id,
          name: props.customer.name,
          iban: props.customer.iban,
          contactName: props.customer.contactName,
          contactEmail: props.customer.contactEmail
        }}
        onSubmit={handleEditCustomer}
      >
        <div className="form">
          <Form>
            <Paper className="customerDetailForm" elevation={10}>
              <CustomFormGroup>
                <Field
                  component={TextField}
                  name="name"
                  type="text"
                  label="Klantnaam"
                  variant="outlined"
                />
              </CustomFormGroup>

              <CustomFormGroup>
                <Field
                  component={TextField}
                  type="text"
                  label="Rekeningnummer"
                  name="iban"
                  variant="outlined"
                />
              </CustomFormGroup>

              <CustomFormGroup>
                <Field
                  component={TextField}
                  type="text"
                  name="contactName"
                  label="Contact"
                  variant="outlined"
                />
              </CustomFormGroup>

              <CustomFormGroup>
                <Field
                  component={TextField}
                  type="email"
                  label="Contact email"
                  name="contactEmail"
                  variant="outlined"
                />
              </CustomFormGroup>
            </Paper>
            <CustomFormGroup>
              <Button
                variant="contained"
                color="primary"
                type="submit"
              >
                Opslaan
                </Button>
            </CustomFormGroup>
          </Form>
        </div>
      </Formik>
    </div>
  );
};

export default EditCustomer;